import React from 'react';
import { hot } from 'react-hot-loader';
import { translate } from '../../../utils/locale';
import s from './DeclarationHeading.scss';

const DeclarationHeading = ({ content = {}, setup }) => (
	<div className={s.declarationHeading}>
		{
			content?.number?.url && (
				<div className={s.declarationHeading_icon}>
					<svg width="10" height="38" viewBox="0 0 10 38" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M9.53271 0.448591L9.19627 0C3.5888 4.37383 0 11.2149 0 18.8411C0 26.4673 3.5888 33.3084 9.19627 37.6822L9.53271 37.2336C4.14953 32.9719 0.560747 26.3551 0.560747 18.8411C0.560747 11.3271 4.03738 4.71027 9.53271 0.448591Z" fill="black" />
					</svg>
					<div className={s.declarationHeading_icon_number}>
						<img src={content.number.url} alt={content.number.alt} />
					</div>
					<svg width="11" height="38" viewBox="0 0 11 38" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M0.805185 0L0.46875 0.448591C5.85193 4.71027 9.44071 11.3271 9.44071 18.8411C9.44071 26.243 5.96408 32.9719 0.46875 37.2336L0.805185 37.6822C6.41266 33.3084 10.0015 26.4673 10.0015 18.8411C10.0015 11.2149 6.41266 4.37383 0.805185 0Z" fill="black" />
					</svg>
				</div>
			)
		}
		<div className={s.declarationHeading_headings}>
			<h3 className={s.declarationHeading_headings_subHeading}>{ translate(setup, content.subHeading) }</h3>
			<h2 className={s.declarationHeading_headings_heading}>{ translate(setup, content.heading) }</h2>
		</div>
	</div>
);

export default hot(module)(DeclarationHeading);
